module.exports = __webpack_public_path__ + "img/ic-package-slip.1953ae6d.svg";